export const SESSION_KEY = 'session_key';
export const SESSION_SEQUENCE = 'session_seq';
export const CALL_ID = 'call_id';
export const API_KEY = 'api_key';
export const REUSE_SESSION = 'reuse_session'
export const CLIENT_ID = 'client_id';